module.exports = __webpack_public_path__ + "img/1977-neue-technik.ce27bfc4.jpg";